/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_1_Item_1_TitleInputs */

const en_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Golf Hall of Fame`)
};

const es_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salón de la fama del golf de Iowa`)
};

const de_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhmeshalle des Golfsports in Iowa`)
};

const zh_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`爱荷华州高尔夫名人堂`)
};

const ar_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعة مشاهير غولف Iowa`)
};

const fr_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temple de la renommée du golf de l’Iowa`)
};

const vi_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đại sảnh danh vọng Golf Iowa`)
};

const sw_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukumbi wa Umaarufu wa Gofu wa Iowa`)
};

const th_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หอเกียรติยศกอล์ฟไอโอวา`)
};

const bs_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuća slavnih golfa Iowe`)
};

const ja_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイオワ州ゴルフ殿堂`)
};

const ko_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa 골프 명예의 전당`)
};

const pt_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall da Fama do Golfe de Iowa`)
};

const it_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galleria della fama del golf dell’Iowa`)
};

const sv_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowas äreshall för golf`)
};

const nl_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eregalerij van het golf in Iowa`)
};

const da_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowas æresgalleri for golf`)
};

const nb_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowas æresgalleri for golf`)
};

const fi_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowan golfin kunniagalleria`)
};

const pl_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeria Sław Golfa Iowa`)
};

const ru_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зал славы гольфа Iowa`)
};

const tr_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Golf Şöhretler Salonu`)
};

const hi_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa गोल्फ हॉल ऑफ फेम`)
};

const id_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeri Kehormatan Golf Iowa`)
};

const ms_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dewan Kemasyhuran Golf Iowa`)
};

const cs_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Síň slávy golfu v Iowě`)
};

const el_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αίθουσα Φήμης του γκολφ της Iowa`)
};

const he_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היכל התהילה של הגולף ב-Iowa`)
};

const af_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Golf Eregalery`)
};

const hu_about_content_honor_1_item_1_title = /** @type {(inputs: About_Content_Honor_1_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Golf Hírességek Csarnoka`)
};

/**
* | output |
* | --- |
* | "Iowa Golf Hall of Fame" |
*
* @param {About_Content_Honor_1_Item_1_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_1_item_1_title = /** @type {((inputs?: About_Content_Honor_1_Item_1_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_1_Item_1_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_1_item_1_title(inputs)
	if (locale === "de") return de_about_content_honor_1_item_1_title(inputs)
	if (locale === "zh") return zh_about_content_honor_1_item_1_title(inputs)
	if (locale === "ar") return ar_about_content_honor_1_item_1_title(inputs)
	if (locale === "fr") return fr_about_content_honor_1_item_1_title(inputs)
	if (locale === "vi") return vi_about_content_honor_1_item_1_title(inputs)
	if (locale === "sw") return sw_about_content_honor_1_item_1_title(inputs)
	if (locale === "th") return th_about_content_honor_1_item_1_title(inputs)
	if (locale === "bs") return bs_about_content_honor_1_item_1_title(inputs)
	if (locale === "ja") return ja_about_content_honor_1_item_1_title(inputs)
	if (locale === "ko") return ko_about_content_honor_1_item_1_title(inputs)
	if (locale === "pt") return pt_about_content_honor_1_item_1_title(inputs)
	if (locale === "it") return it_about_content_honor_1_item_1_title(inputs)
	if (locale === "sv") return sv_about_content_honor_1_item_1_title(inputs)
	if (locale === "nl") return nl_about_content_honor_1_item_1_title(inputs)
	if (locale === "da") return da_about_content_honor_1_item_1_title(inputs)
	if (locale === "nb") return nb_about_content_honor_1_item_1_title(inputs)
	if (locale === "fi") return fi_about_content_honor_1_item_1_title(inputs)
	if (locale === "pl") return pl_about_content_honor_1_item_1_title(inputs)
	if (locale === "ru") return ru_about_content_honor_1_item_1_title(inputs)
	if (locale === "tr") return tr_about_content_honor_1_item_1_title(inputs)
	if (locale === "hi") return hi_about_content_honor_1_item_1_title(inputs)
	if (locale === "id") return id_about_content_honor_1_item_1_title(inputs)
	if (locale === "ms") return ms_about_content_honor_1_item_1_title(inputs)
	if (locale === "cs") return cs_about_content_honor_1_item_1_title(inputs)
	if (locale === "el") return el_about_content_honor_1_item_1_title(inputs)
	if (locale === "he") return he_about_content_honor_1_item_1_title(inputs)
	if (locale === "af") return af_about_content_honor_1_item_1_title(inputs)
	if (locale === "hu") return hu_about_content_honor_1_item_1_title(inputs)
	return en_about_content_honor_1_item_1_title(inputs)
});